import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestOffersReorder } from "./offersReorder.request";

const useOffersReorder = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestOffersReorder,
    ...options
  });
};

export default useOffersReorder;
